import React from 'react';
import PropTypes from 'prop-types';
import Column from '../../../../models/SpreadsheetReportConfigs/Column.js';
import { useDrop } from 'react-dnd';
import './index.scss';

const ItemTypes = {
  COLUMN: 'column',
};

const DropZone = ({ index, onMove }) => {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: ItemTypes.COLUMN,
    drop: (draggedItem) => {
      if (draggedItem.index !== index) {
        onMove(draggedItem.index, index);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const isActive = canDrop && isOver;

  return (
    <div ref={drop} className={`output-column-dnd-drop-zone`}>
      <div
        className={`output-column-dnd-drop-zone-content ${
          isActive ? 'output-column-dnd-drop-zone-content-active' : ''
        }`}
      ></div>
    </div>
  );
};

const OutputColumnDNDContainer = ({ columns, renderItem, onMove }) => {
  return (
    <div className='output-column-dnd-container'>
      <DropZone index={0} onMove={onMove} isFirst={true} />

      {columns.map((column, index) => (
        <React.Fragment key={column.id}>
          <div className='output-column-dnd-item-wrapper'>
            {renderItem({
              column,
              index,
              key: column.id,
            })}
          </div>
          <DropZone index={index + 1} onMove={onMove} />
        </React.Fragment>
      ))}
    </div>
  );
};

DropZone.propTypes = {
  index: PropTypes.number.isRequired,
  onMove: PropTypes.func.isRequired,
  isFirst: PropTypes.bool,
};

OutputColumnDNDContainer.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape(Column.propTypes)).isRequired,
  renderItem: PropTypes.func.isRequired,
  onMove: PropTypes.func.isRequired,
};

export default OutputColumnDNDContainer;
